import axios from "axios";

async function buildTree(data, patToken, patType) {
  const treeNodes = [];

  const apiPromises = [];

  for (const item of data) {
    //[working]console.log(item);
    if (item.type === "file") {
      const fileNode = {
        id: item.path + item.name,
        name: item.name,
        type: "file",
        url: item.url,
        patType
      };
      treeNodes.push(fileNode);
    } else if (item.type === "dir") {
      apiPromises.push(
        axios
          .get(item.url, {
            headers: {
              Authorization: `Bearer ${patToken}`,
            },
          })
          .then((folderResponse) => {
            const folderData = folderResponse.data;
            return buildTree(folderData, patToken,patType);
          })
          .then((folderNodes) => {
            const folderNode = {
              id: item.path + item.name,
              name: item.name,
              type: "folder",
              children: folderNodes,
              patType
            };
            treeNodes.push(folderNode);
          })
          .catch((error) => {
            console.error("Error fetching folder contents:", error);
          })
      );
    }
  }
  await Promise.all(apiPromises);
  return treeNodes;
}

export default buildTree;
